<form #loginForm="ngForm">
  <div class="container-loader" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
    <!-- <mat-spinner class="loader" strokeWidth="4" [color]="warn" [diameter]="50"></mat-spinner> -->
  </div>
  <div class="modal-header">
    <h3 class="modal-title">{{ username }}</h3>
    <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="onDecline()">
        <span aria-hidden="true" style="font-size: 25px;">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div [ngClass]="{'arrow-bottom':true, 'pw-validation-has-error' : true, 'show' : isEmptyPassword }">
        <span>Password is required</span>
    </div>
    <div class="flex-group">
      <span class="flex-addon">
          <img src="../../assets/images/profile-circle.png" width="20" height="20">
      </span>
      <input #password autofocus type="password" [ngClass]="{'form-control password-tb': true, 'red-border': isEmptyPassword}" name="password" 
      placeholder="Password" id="password" required [disabled]="submitted"/>
    </div>
    <div (capsLock)="capsOn=$event">
      <div *ngIf="capsOn" [ngClass]="{'caps-error' : true}">
        <span>Caps Lock is On</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <a href="javascript:void(0)" class="forgot-password-link" (click)="forgotLoginDetails()">Forgot your password?</a>
    <button type="submit" class="btn btn-primary login-btn" (click)="onConfirm(password.value)" [disabled]="submitted">LOGIN</button>
  </div>
</form>